import { component } from 'picoapp'

export default component((node, ctx) => {
    /**
     * Toggle cart
     */
    const cartToggles = node.querySelectorAll('.js-cart-drawer-toggle')

    for (let i = 0; i < cartToggles.length; i++) {
        cartToggles[i].addEventListener('click', (e) => {
            e.preventDefault()

            ctx.emit('cart:toggle', (state) => {
                return {
                    cartOpen: !state.cartOpen,
                }
            })
        })
    }
    const headerContent = node.querySelector('.site-header__content')
    const headerNav = node.querySelector('.site-header__nav')
    const stickyHeader = node.querySelector('.site-header__sticky')
    const megaMenuToggles = node.querySelectorAll('.hasMegaMenu')
    megaMenuToggles.forEach((ele) => {
        ele.addEventListener('mouseenter', () => {
            headerContent.classList.add('site-header__dark')
            headerNav.classList.add('site-header__dark')
            stickyHeader.classList.add('site-header__dark')
        })

        ele.addEventListener('mouseleave', () => {
            headerContent.classList.remove('site-header__dark')
            headerNav.classList.remove('site-header__dark')
            stickyHeader.classList.remove('site-header__dark')
        })
    })

    /**
     * Update cart count
     */
    const cartCounts = document.querySelectorAll('[data-cart-count]')

    ctx.on('cart:updated', (state) => {
        cartCounts.forEach(cartCount => {
            cartCount.innerHTML = state.cart.item_count
        })
    })

    ctx.on('upsell:added', (state) => {
        cartCounts.forEach(cartCount => {
            cartCount.innerHTML = state.cart.item_count
        })
    })

    cartCounts.forEach(cartCount => {
        cartCount.innerHTML = ctx.getState().cart.item_count
    })


    /**
     * Mobile menu
     */
    const burgers = node.querySelectorAll('[data-burger-icon]')
    const mobileMenuLayer = node.querySelector('[data-mobile-menu-layer]')
    const body = document.querySelector('body')

    burgers.forEach(burger => {
        burger.addEventListener('click', () => {
            body.classList.add('mobile-menu-open')
        })
    })

    document.addEventListener('click', (e) => {
        if (e.target == mobileMenuLayer)
            body.classList.remove('mobile-menu-open')
    })


    /**
     * Set header position and body padding-top
     */
    const headerPosition = () => {
        body.style.paddingTop = `${node.getBoundingClientRect().height}px`
        node.style.position = 'absolute'
    }

    headerPosition()
    window.addEventListener('resize', headerPosition)


    /**
     * Sticky header nav on scroll
     */
    const  scrollHeight = node.getBoundingClientRect().height

    const stickyNav = () => {
        if (window.pageYOffset > scrollHeight) body.classList.add('is--sticky')
        else body.classList.remove('is--sticky')
    }

    stickyNav()
    document.addEventListener('scroll', stickyNav)
})
